<template>
    <div v-if="authFrameLoaded" :display="isIframeRoute ? 'block' : 'none'" h-full w-full>
        <div
            v-for="i in iframeIMList"
            :key="i"
            :style="{ display: i === calmelCaserouteKey ? 'block' : 'none' }"
            h-full
            w-full
        >
            <n-spin h-full w-full :show="getLoading(i)">
                <div w-full h-full>
                    <iframe
                        :ref="(v) => setRef(v as Element, i)"
                        :src="getSrc(i)"
                        frameborder="0"
                        w-full
                        h-full
                    />
                </div>
            </n-spin>
        </div>
    </div>
    <!-- <div v-if="showIframe">
        <iframe
            :ref="(v) => authFrame = v as HTMLIFrameElement"
            display-none
            :src="src"
            frameborder="0"
            h-0
            w-0
        />
    </div> -->
</template>

<script setup lang="ts">
import camelcase from 'camelcase';
import decamelize from 'decamelize';
import type { ComponentPublicInstance } from 'vue';
import { normalizePath, routeMap } from '../utils/router';
import { useCommonStore } from '~/stores/common';
import { useUserStore } from '~/stores/user';
import { useAuthToken } from '~/utils/token';

const { authToken } = useAuthToken();
const { locale } = useTypedI18n();
const commonStore = useCommonStore();
const { currentRouteKey } = storeToRefs(commonStore);
const calmelCaserouteKey = computed(() => {
    const a = camelcase(currentRouteKey.value.replaceAll('/', '-'), {
        pascalCase: true,
        preserveConsecutiveUppercase: true,
    });
    return a;
});
const router = useRouter();
const route = useRoute();
const isIframeRoute = computed(() =>
    ['/imservice/ima', '/imservice/imb', '/imservice/imc'].some((i) =>
        router.currentRoute.value.path.includes(i),
    ),
);

const userStore = useUserStore();
// const showIframe = ref(false);
const authFrameLoaded = ref(true);

// 智己不需要验证
// const src = `${import.meta.env.VITE_CDC_AUTH_TARGET}esc-sso/app/forward?ssoType=saml&appId=${
//     import.meta.env.VITE_CDC_APPID
// }&accountNo=${userStore.userInfo?.username}`;

const iframeIMList = computed(() => commonStore.iframeIMList);
const iframeMap = ref(new Map<string, HTMLIFrameElement>());
const loadingMap = ref(new Map<string, boolean>());
const authFrame = ref<HTMLIFrameElement | null>(null);
const getMessageData = ref<any>(null);

const getMessage = (event) => {
    getMessageData.value = event.data;
    router.push(getMessageData.value.targetPath);
};

onMounted(() => {
    window.addEventListener('message', getMessage);
});

onBeforeUnmount(() => {
    window.removeEventListener('message', getMessage);
    getMessageData.value = null;
});

const buildQueryString = (params: any) => {
    return Object.entries(params)
        .map(([key, value]: any) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
};

const srcUrl = ref<any>(null);

const getSrc = (name: string) => {
    const item = routeMap.get(normalizePath(decamelize(name, { separator: '/' })));
    const lang = locale.value === Locales.zhCN ? 'CHS' : 'ENG';
    const epcLang = locale.value === Locales.zhCN ? 'CHS' : 'ENG';
    const loginChannel = 'SSNW';
    const token = authToken.value;

    if (item && item.isFrame === '1') {
        srcUrl.value = item.component;
        if (!getMessageData.value) {
            // 页面直接token验证
            return `${item.component}${
                // item.component?.includes('?')
                item.component?.charAt(item.component?.length - 1) === '?'
                    ? `&langCode=${lang}&loginChannel=${loginChannel}&token=${token}`
                    : `?langCode=${lang}&loginChannel=${loginChannel}&token=${token}`
            }`;
        } else {
            const jumpUrl = ref<any>(null);
            jumpUrl.value = `${item.component}${
                // item.component?.includes('?')
                item.component?.charAt(item.component?.length - 1) === '?'
                    ? `&langCode=${lang}&loginChannel=${loginChannel}&token=${token}`
                    : `?langCode=${lang}&loginChannel=${loginChannel}&token=${token}` +
                      `&${buildQueryString(getMessageData.value.opParams)}`
            }`;
            return jumpUrl.value;
        }
    }
    return '';
};

watch(
    () => commonStore.locale,
    (newLocale) => {
        // authFrameLoaded.value = false;
        // nextTick(() => {
        //     authFrameLoaded.value = false;
        //     authFrameLoaded.value = true;
        // });
        const lang = locale.value === Locales.zhCN ? 'CHS' : 'ENG';
        iframeMap.value.forEach((iframeRef) => {
            if (iframeRef?.contentWindow) {
                const message = {
                    action: 'langChange',
                    opParams: { langCode: lang },
                };
                iframeRef.contentWindow.postMessage(message, '*');
            } else {
                console.error(`iframe ${iframeRef} not ready`);
            }
        });
    },
);

const setRef = (iframeRef: Element | ComponentPublicInstance | null, iframeName: string) => {
    if (iframeRef) {
        iframeMap.value.set(iframeName, iframeRef as HTMLIFrameElement);
        if (!iframeMap.value.has(iframeName)) {
            loadingMap.value.set(iframeName, true);
        }
        (iframeRef as HTMLIFrameElement).onload = () => {
            loadingMap.value.set(iframeName, false);
        };
    }
};

const getLoading = (name: string) => {
    const loading = loadingMap.value.get(name);
    return loading ?? true;
};

watchArray(
    () => [...iframeIMList.value],
    (v, oldV, added, removed) => {
        removed.forEach((i) => {
            loadingMap.value.set(i, true);
        });
    },
);

// if (userStore.userInfo?.idaasUser === 1) {
//     showIframe.value = true;
// }

// watch(authFrame, (v) => {
//     if (v)
//         v.onload = () => {
//             authFrameLoaded.value = true;
//         };
// });
</script>

<style scoped>
:deep(.n-spin-content) {
    height: 100%;
}
</style>
